import object from '@mailobj-browser/front/js/utils/object.js'

const block = 'ea_credit'

export const elements = object(null, {
  subscription_pack_name: `${block}__subscription_pack_name`,
  subscription_price: `${block}__subscription_price`,
  subscription_label: `${block}__subscription_label`,
  subscription_value: `${block}__subscription_value`,
  // subscription_current: `${block}__subscription_current`,
})

export const modifiers = object(null, {
  subscription_label: object(null, {
    sub_meet: `${elements.subscription_label}-sub_meet`,
    sub_npremium: `${elements.subscription_label}-sub_npremium`,
    sub_storage: `${elements.subscription_label}-sub_storage`,
    sub_websites: `${elements.subscription_label}-sub_websites`,
  }),
  subscription_price: object(null, {
    old: `${elements.subscription_price}-old`,
    pack: `${elements.subscription_price}-pack`,
    sub_duration: `${elements.subscription_price}-sub_duration`,
    sub_meet: `${elements.subscription_price}-sub_meet`,
    sub_npremium: `${elements.subscription_price}-sub_npremium`,
    sub_storage: `${elements.subscription_price}-sub_storage`,
    sub_websites: `${elements.subscription_price}-sub_websites`,
  }),
  subscription_value: object(null, {
    sub_duration: `${elements.subscription_value}-sub_duration`,
  }),
})